"use strict";

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FieldUtils = function FieldUtils() {
  _classCallCheck(this, FieldUtils);
};

exports.default = FieldUtils;

_defineProperty(FieldUtils, "getNumberFromField", function (value) {
  if (!value) {
    return value;
  }

  if (typeof value === 'string') {
    //Replace currency string
    return parseFloat(value.replace(/[$,]/g, ''));
  }

  return value;
});
//# sourceMappingURL=FieldUtils.js.map